import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { AppRoutingModule } from '@appcatalyst/ng-cms-core-lib';
import { CoreRoutingModule } from '@appcatalyst/ng-cms-core-lib';
import { CoreConfig } from '@appcatalyst/ng-cms-core-lib';
import { CoreModule } from '@appcatalyst/ng-cms-core-lib';
import { environment } from '../environments/environment';
import { CmsModule } from 'src/app/cms/cms.module';
import { AdminModule } from './admin/admin.module';


const config: CoreConfig = {
  title: environment.title,
  authUrl: environment.authUrl,
  resourceUrl: environment.resourceUrl,
  description: environment.description,
  registerButton: false,
  authorizedHomeRoute: '/groups'
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    RouterModule,
    NgbModule.forRoot(),
    CoreModule.forRoot(config),
    CmsModule,
    AdminModule,
    AppRoutingModule,
    CoreRoutingModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
